<div class="eventq-searchable-list">
  @if (showSearch()) {
    <div class="eventq-searchable-list__search">
      <input
        class="eventq-searchable-list__search-input"
        type="search"
        [placeholder]="searchPlaceholder()"
        [value]="searchQuery()"
        [attr.aria-label]="searchPlaceholder()"
        (input)="onSearchInput($event)"
      />
      <mat-icon class="eventq-searchable-list__search-icon" aria-hidden="true">search</mat-icon>
    </div>
  }

  <div class="eventq-searchable-list__extra">
    <ng-content select="[eventqSearchableListExtra]" />
  </div>

  @if (loading()) {
    <div class="eventq-searchable-list__skeleton" aria-hidden="true">
      @for (index of skeletonIndexes(); track index) {
        <div class="eventq-searchable-list__skeleton-row">
          <div class="eventq-searchable-list__skeleton-block eventq-searchable-list__skeleton-block--primary"></div>
          <div class="eventq-searchable-list__skeleton-block eventq-searchable-list__skeleton-block--secondary"></div>
        </div>
      }
    </div>
  } @else if (!showRows()) {
    @if (rows().length === 0) {
      <p class="eventq-searchable-list__empty">{{ emptyMessage() }}</p>
    }
  } @else if (rows().length === 0) {
    <p class="eventq-searchable-list__empty">{{ emptyMessage() }}</p>
  } @else {
    <eventq-scroll-area
      class="eventq-searchable-list__scroll"
      axis="vertical"
      [surface]="appearance() === 'popover' ? 'deep' : 'midnight'"
      [fill]="fillHeight()"
      [style]="scrollStyle()"
      (scroll)="onListScroll($event)"
    >
      <ul class="eventq-searchable-list__list" role="listbox" [attr.aria-label]="listAriaLabel()">
        @for (row of visibleRows(); track row.id) {
          <li>
            @if (selectable()) {
              <button
                type="button"
                class="eventq-searchable-list__row"
                role="option"
                [attr.aria-selected]="isSelected(row.id)"
                [class.eventq-searchable-list__row--selected]="isSelected(row.id)"
                (click)="onRowActivate(row)"
              >
                @if (leadingIcon(row); as icon) {
                  <mat-icon
                    class="eventq-searchable-list__leading-icon"
                    [class.eventq-searchable-list__leading-icon--armed]="leadingIconTone(row) === 'armed'"
                    [class.eventq-searchable-list__leading-icon--disarmed]="
                      leadingIconTone(row) === 'disarmed'
                    "
                    aria-hidden="true"
                    >{{ icon }}</mat-icon
                  >
                }
                <div class="eventq-searchable-list__cells">
                  @for (column of textColumns(); track column.key) {
                    <span
                      class="eventq-searchable-list__cell"
                      [class.eventq-searchable-list__cell--primary]="column.style === 'primary'"
                      [class.eventq-searchable-list__cell--secondary]="column.style === 'secondary'"
                      [class.eventq-searchable-list__cell--body]="!column.style || column.style === 'body'"
                    >
                      {{ cellText(row, column.key) }}
                    </span>
                  }
                </div>
                @if (actionColumns().length > 0) {
                  <div class="eventq-searchable-list__actions">
                    @for (column of actionColumns(); track column.key) {
                      <button
                        type="button"
                        class="eventq-searchable-list__row-action"
                        [class.eventq-searchable-list__row-action--active]="isActionActive(row)"
                        [attr.aria-label]="actionLabel(row, column)"
                        (click)="onActionClick($event, row, column)"
                      >
                        <mat-icon aria-hidden="true">{{ actionIcon(row, column) }}</mat-icon>
                      </button>
                    }
                  </div>
                }
              </button>
            } @else {
              <div
                class="eventq-searchable-list__row eventq-searchable-list__row--static"
                role="option"
                aria-selected="false"
              >
                @if (leadingIcon(row); as icon) {
                  <mat-icon
                    class="eventq-searchable-list__leading-icon"
                    [class.eventq-searchable-list__leading-icon--armed]="leadingIconTone(row) === 'armed'"
                    [class.eventq-searchable-list__leading-icon--disarmed]="
                      leadingIconTone(row) === 'disarmed'
                    "
                    aria-hidden="true"
                    >{{ icon }}</mat-icon
                  >
                }
                <div class="eventq-searchable-list__cells">
                  @for (column of textColumns(); track column.key) {
                    <span
                      class="eventq-searchable-list__cell"
                      [class.eventq-searchable-list__cell--primary]="column.style === 'primary'"
                      [class.eventq-searchable-list__cell--secondary]="column.style === 'secondary'"
                      [class.eventq-searchable-list__cell--body]="!column.style || column.style === 'body'"
                    >
                      {{ cellText(row, column.key) }}
                    </span>
                  }
                </div>
                @if (actionColumns().length > 0) {
                  <div class="eventq-searchable-list__actions">
                    @for (column of actionColumns(); track column.key) {
                      <button
                        type="button"
                        class="eventq-searchable-list__row-action"
                        [class.eventq-searchable-list__row-action--active]="isActionActive(row)"
                        [attr.aria-label]="actionLabel(row, column)"
                        (click)="onActionClick($event, row, column)"
                      >
                        <mat-icon aria-hidden="true">{{ actionIcon(row, column) }}</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </li>
        }
      </ul>
    </eventq-scroll-area>
  }
</div>
